// Copyright (c) 2017 Deere & Company

import actions from '../../action-list';
import {findMatchingKey} from '../../shared/services/claim-shared-helper';

export const updateGoodsInstallationVat = (key, options) => ({
    goodsInstallationVat: findMatchingKey(key, options),
    type: actions.UPDATE_CLAIM_ATTACHMENT_GOODS_INSTALLATION_VAT
});



// WEBPACK FOOTER //
// ./src/claim/attachment/action-creators/update-goods-installation-vat.js